<template>
    <!-- main area -->
    <div class="d-flex align-center justify-center" style="min-height: 300px;">
      <v-row>
        <v-col class="mt-10">
          <v-img class="mx-auto"
            :width="500"
            src="@/assets/welcomemap.png"
          ></v-img>
        </v-col>

        <v-col class="mt-10 mr-5">
            <p class="text-h5">British Columbia Coastal Monitoring Dashboard</p>
            <v-divider></v-divider>
            <p class="text-body-2 mt-4">
              Use this interactive dashboard to explore who’s monitoring what, where along the British Columbian coast from the south coast to the north coast. 
              Data in the dashboard come from the results of the North Central, Central, and South Coast Monitoring Surveys. 
              DFO and its partners are using the survey results to inform Canada wide MPA monitoring.
            </p>
            <br>
            <p class="text-body-2">
              The North Coast Monitoring Survey is now available! If you are actively involved in managing or overseeing monitoring efforts in the North Coast, 
              please help to share your work by taking the survey here.
              We encourage you to explore this dashboard to learn about monitoring projects in each of these regions, make new connections, 
              and continue to grow the monitoring community!
            </p>

        </v-col>
      </v-row>
    </div>
</template>

<script>

export default {
  data () {
    return {
      test: null
    }
  }
}

</script>
